import { isSupabaseConfigured } from "@/lib/env";
import { supabase } from "@/lib/supabase";
import { resolveStoredAssetRef } from "@/features/image-generation";

export const LORE_COVERS_BUCKET = "lore-covers";

function ensureConfigured() {
  if (!isSupabaseConfigured()) {
    throw new Error("Supabase environment variables are not configured.");
  }
}

function getFileExtension(file: File) {
  const lastDotIndex = file.name.lastIndexOf(".");
  return lastDotIndex >= 0 ? file.name.slice(lastDotIndex) : "";
}

export function buildLoreCoverPath(userId: string, projectId: string, loreEntryId: string, file?: File) {
  return `${userId}/${projectId}/${loreEntryId}${file ? getFileExtension(file) : ""}`;
}

export async function uploadLoreCover(
  userId: string,
  projectId: string,
  loreEntryId: string,
  file: File,
) {
  ensureConfigured();

  const path = buildLoreCoverPath(userId, projectId, loreEntryId, file);

  const { data, error } = await supabase.storage
    .from(LORE_COVERS_BUCKET)
    .upload(path, file, {
      cacheControl: "3600",
      contentType: file.type || undefined,
      upsert: true,
    });

  if (error) {
    throw error;
  }

  return data.path;
}

export async function deleteLoreCover(path: string) {
  ensureConfigured();
  const resolved = resolveStoredAssetRef(path, LORE_COVERS_BUCKET);

  if (!resolved) {
    return;
  }

  const { error } = await supabase.storage
    .from(resolved.bucket)
    .remove([resolved.path]);

  if (error) {
    throw error;
  }
}

export async function createLoreCoverSignedUrl(path: string) {
  ensureConfigured();
  const resolved = resolveStoredAssetRef(path, LORE_COVERS_BUCKET);

  if (!resolved) {
    throw new Error("Lore cover path is missing.");
  }

  const { data, error } = await supabase.storage
    .from(resolved.bucket)
    .createSignedUrl(resolved.path, 60 * 30);

  if (error) {
    throw error;
  }

  return data.signedUrl;
}
